import type { ReactNode } from "react";
import { Text } from "react-native";
import type { StyleProp, TextStyle } from "react-native";
import { semanticColors } from "../theme/tokens";

type Props = {
  children: ReactNode;
  numberOfLines?: number;
  style?: StyleProp<TextStyle>;
};

/**
 * Canonical supporting subtitle for ordinary rows and card headers.
 * 13px / 18px / text-light with a 2px title gap.
 */
export function SupportingSubtitleText({
  children,
  numberOfLines,
  style,
}: Props) {
  return (
    <Text
      className="font-dm-sans"
      numberOfLines={numberOfLines}
      style={[
        {
          fontSize: 13,
          lineHeight: 18,
          color: semanticColors.typography.supporting,
          marginTop: 2,
        },
        style,
      ]}
    >
      {children}
    </Text>
  );
}

export default SupportingSubtitleText;
